import { render, staticRenderFns } from "./ControlModalForm.vue?vue&type=template&id=006dbf8b&"
import script from "./ControlModalForm.vue?vue&type=script&lang=js&"
export * from "./ControlModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports